import { memo, useMemo, useCallback, createRef } from 'react';
import MarketDepthGrid from './MarketOverview/MarketDepthGrid';
import { LAYOUT_TYPE, WATCHLIST_GRID_INDEX } from '../utils/global_variables';
import { useSelector } from 'react-redux';
import uniqBy from 'lodash/uniqBy';
const AllExchangesMarketDepth = ({ onValueClick = () => { }, heading, scripOverviewData, expandScripOverviewModel, layoutType = LAYOUT_TYPE.HORIZONTAL, props }) => {

    /* Neha Kumari : 20-07-23 : Market Depth Grid data  --> start  */

    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    const arrDistinctScripExchanges = useMemo(() => uniqBy(arrScripExchanges, WATCHLIST_GRID_INDEX.SEGMENT_ID), [arrScripExchanges]);
    //Vaibhav Singh : 16-11-23:BT-1090109: Fixed market depth showing in Overview: Start
    let exchangePresent = [];
    arrDistinctScripExchanges?.forEach((each, i) => {
        exchangePresent.push(each[WATCHLIST_GRID_INDEX.EXCHANGE]);
    });
    // {/* Vaibhav Singh: 06-12-23: BT-109089: added validation logic : Start */ }
    if (scripOverviewData?.length && !exchangePresent?.includes(scripOverviewData?.[WATCHLIST_GRID_INDEX.EXCHANGE])) {
        arrDistinctScripExchanges?.unshift(scripOverviewData);
    }
    // {/* Vaibhav Singh: 06-12-23: BT-109089: added validation logic : End */ }
    //Vaibhav Singh : 16-11-23:BT-109089: Fixed market depth showing in Overview: End
    let arrRef = Array.from({ length: arrDistinctScripExchanges.length }, () => [
        createRef(),
        createRef(),
    ]);

    const getRowId = useCallback((params) => {
        if (params?.data) {
            return params?.data?.id;
        } else { }
    }, []);
    return (
        <>
            <div className={`${heading ? 'scripoverview-fieldset' : ''}`}>
                {(heading) ? <div className='scripoverview-legend'>MARKET DEPTH</div> : null}
                {/* <div className='icon-16 icon-grid icon-primary me-2' onClick={()=>handleMarketDepthChange(false)}></div>   Vaibhav Singh: 28-10-24: This will be removed when Overview UI gets Completed
                <div className='icon-16 icon-ladder icon-primary me-2' onClick={()=>handleMarketDepthChange(true)}></div> */}
                <div className='market-depth-web-wrapper'>
                    {//!marketDepthToShow?
                        arrDistinctScripExchanges.length > 0 && arrDistinctScripExchanges?.map((each, index) => (
                            <div className={`${layoutType === LAYOUT_TYPE.HORIZONTAL ?  'web-columns' : 'mobile-columns' }`}>
                                <MarketDepthGrid ref={arrRef[index]} getRowId={getRowId} layoutType={layoutType} scripData={each} onValueClick={onValueClick} className='overflow-hidden' expandScripOverviewModel={expandScripOverviewModel} />
                            </div>
                        ))
                        // :
                        // null
                        //Commenting until Market depth is complete
                        // <PriceLadderView arrDistinctScripExchanges={arrDistinctScripExchanges} expandScripOverviewModel={expandScripOverviewModel}/>  Vaibhav Singh: 28-10-24: This will be removed when Overview UI gets Completed
                    }
                </div>
            </div>
        </>
    );
};
/* Neha Kumari : 20-07-23 : Market Depth Grid data  --> end  */

export default memo(AllExchangesMarketDepth);